export default __webpack_public_path__ + "static/media/chip_1000.27e5671e.svg";